import {PAYMENT_TYPE_ID_COLLECTION} from "@/utils/Constant";

export default {
  props: {
    id: {
      type: String,
      default: PAYMENT_TYPE_ID_COLLECTION // 代收 -> 110, 代付 -> 120
    }
  },
  data() {
    return {
      isSubmit: true,
      selectList: [],
      radioList: [],
      currentSelectValue: null,
      currentRadioValue: null,
      datasets: [
        {
          label: this.$t('text.today'),
          data: [],
          bordercolor: "rgb(223, 46, 56)"
        },
        {
          label: this.$t('text.yesterday'),
          data: [],
          borderColor: "rgb(109, 169, 228)"
        }
      ],
      plugins: [
        {
          id: "drawLabel",
          afterDraw: (chart) => {
            let ctx = chart.chart.ctx;
            ctx.save();
            ctx.font = "normal 14px 'Helvetica Neue'";
            ctx.fillStyle = "grey";

            ctx.textAlign = "left";
            ctx.fillText(this.$t('text.successRate'), 30, 10);
            ctx.fillText(this.$t('text.time'), chart.chart.width - 70, chart.chart.height - 50);

            ctx.restore();
          }
        }
      ]
    };
  },
  computed: {
    hourLabels() {
      return Array.from({length: 24}, (v, i) => i + 1);
    }
  },
  methods: {
    getSelectList(apiUrl = "", params = {}) {
      this.$axios.get(apiUrl, {params}).then((res) => {
        if (res.code === 200) {
          this.selectList = res.data;
        }
      });
    },
    getRadioList(apiUrl = "", params = {}) {
      return this.$axios.get(apiUrl, {params, cache: true}).then((res) => {
        if (res.code === 200) {
          this.radioList = [
            {
              channelId: "",
              channelName: this.$t('option.all'),
              appId: "",
              merchantName: this.$t('option.all')
            },
            ...res.data
          ];
        }
      });
    },
    getChartList(params = {}) {
      if (!this.currentSelectValue) {
        this.datasets[0].data = [];
        this.datasets[1].data = [];
        return;
      }

      if (!this.isSubmit) return;

      this.isSubmit = false;

      let apiUrl = "/Chart/orderTransactionRate";
      this.$axios
        .get(apiUrl, {params, cache: true})
        .then((res) => {
          if (res.code === 200) {
            const todayData = res.data["todayList"].map((d) => {
              return d.transactionRate;
            });

            this.datasets[0].data = todayData;
            const yesterdayData = res.data["yesterdayList"].map((d) => {
              return d.transactionRate;
            });
            this.datasets[1].data = yesterdayData;
          }
        })
        .finally(() => {
          this.isSubmit = true;
        });
    }
  }
};
